import { useSelector } from 'bundles/research/index/store/hooks';

import { researchInformationMappings } from 'helpers/research/research_info_mappings';
import type { CustomFieldSchema } from 'bundles/crm/types';

export function useCurrentColumnProps() {
  const currentColumns = useSelector(state => state.session.currentColumns);
  const edgeCrm = useSelector(state => state.features.edgeCrm);
  const customFieldConfigs = useSelector(state => state.static.customFields);

  return {
    currentColumns: getCurrentColumns(currentColumns, edgeCrm),
    informationMappings: getInformationMappings(edgeCrm, customFieldConfigs),
  };
}

function getCurrentColumns(currentColumns: string[], edgeCrm?: boolean) {
  return currentColumns.filter(column => column !== 'databaseName' || !edgeCrm);
}

function getInformationMappings(edgeCrm?: boolean, customFieldConfigs?: CustomFieldSchema[]) {
  const informationMappings = { ...researchInformationMappings };

  if (edgeCrm) {
    delete informationMappings.propertyInformation.mappings.databaseName;
    informationMappings.propertyInformation.mappings.activeDealCount = 'Active Deals';
    informationMappings.propertyInformation.mappings.activeEdgeProjectCount = 'Active Listings';
  }

  if (customFieldConfigs?.length) {
    informationMappings.customFields = {
      title: 'Custom Fields',
      mappings: {},
      key: 'custom-fields',
    };
    customFieldConfigs.forEach((config) => {
      informationMappings.customFields.mappings[config.slug] = config.label;
    });
  }

  return informationMappings;
}
